// Angular
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
// RxJS
import { environment } from "../../../../../environments/environment";
// Models
import { StylesDTO } from "../models/StylesDTO";


const API_URL = `${environment.API_URL}api/brandings/current`;

@Injectable({
    providedIn: "root",
})
export class StylesService {
    private request;

    constructor(private http: HttpClient) {}

    async getConfigStyles() {
        let config = JSON.parse(localStorage.getItem("stylesConfig"));
        if (!config) {
            if (!this.request) {
                this.request = this.getConfigs();
            }
            config = await this.request;
            localStorage.setItem("stylesConfig", JSON.stringify(config));
            let date = this.getDate();
            localStorage.setItem("stylesConfigDate", JSON.stringify(date));
        } else {
            if (environment.CACHE_STYLE_CONFIG) {
                let stylesConfigDate = JSON.parse(
                    localStorage.getItem("stylesConfigDate")
                );
                let date = this.getDate();
                if (!stylesConfigDate || stylesConfigDate < date) {
                    if (!this.request) {
                        this.request = this.getConfigs();
                    }
                    this.request.then((value) => {
                        localStorage.setItem(
                            "stylesConfig",
                            JSON.stringify(value)
                        );
                        localStorage.setItem(
                            "stylesConfigDate",
                            JSON.stringify(date)
                        );
                    });
                }
            }
        }

        return config;
    }

    getConfigs(): Promise<StylesDTO> {
        return this.http.get<StylesDTO>(API_URL).toPromise();
    }

    async getLogoHeader() {
        let stylesConfig = await this.getConfigStyles();
        return stylesConfig.headerLogo;
    }

    private getDate() {
        return new Date().toISOString().substring(0, 10);
    }

    async getLogoLogin() {
        let stylesConfig = await this.getConfigStyles();
        return stylesConfig.loginLogo;
    }
}
